import {getAjaxData} from "@soinproduction/kit/src/functions/ajax-get-data";
import {loaderInstanse} from "@soinproduction/kit/src/functions/scripts/loaderInstanse";

document.addEventListener('DOMContentLoaded', function () {
    const { ajax_url, nonce , theme_url } = ajax_params;

    const section    = document.querySelector('.section-archive-cases');
    if (!section) return;

    const form       = section.querySelector('.case-filters__form');
    const applyBtn   = form?.querySelector('[data-action="apply"]');
    const resetBtn   = form?.querySelector('[data-action="reset"]');
    const checkboxes = Array.from(form?.querySelectorAll('.case-filters__checkbox') || []);
    const list       = section.querySelector('.case-cards');
    const showAllBtn = section.querySelector('[data-show-all]');
    const tagsBox    = section.querySelector('[data-active-tags]');
    const countBox   = section.querySelector('[data-active-count]');
    if (!list) return;

    const taxonomy     = list.dataset.taxonomy;
    const postType     = list.dataset.postType || 'cases';
    const allowedTerms = list.dataset.allowedTerms || '';

    const VISIBLE_LIMIT = 4;
    let expanded = false;
    let isBusy = false;

    function setBtnEnabled(btn, enabled) {
        if (!btn) return;
        if (enabled) {
            btn.classList.remove('is-disabled');
            btn.removeAttribute('disabled');
            btn.setAttribute('aria-disabled', 'false');
            btn.style.pointerEvents = '';
        } else {
            btn.classList.add('is-disabled');
            btn.setAttribute('disabled', 'disabled');
            btn.setAttribute('aria-disabled', 'true');
            btn.style.pointerEvents = 'none';
        }
    }

    function collectSelected() {
        return checkboxes.filter(cb => cb.checked).map(cb => ({
            id: cb.value,
            name: cb.getAttribute('data-term-name') || cb.value
        }));
    }

    function truncateList() {
        const items = Array.from(list.children);
        if (expanded) {
            items.forEach(li => li.style.display = '');
            if (showAllBtn) showAllBtn.style.display = 'none';
            return;
        }
        if (items.length > VISIBLE_LIMIT) {
            items.forEach((li, i) => li.style.display = i < VISIBLE_LIMIT ? '' : 'none');
            if (showAllBtn) showAllBtn.style.display = '';
        } else {
            items.forEach(li => li.style.display = '');
            if (showAllBtn) showAllBtn.style.display = 'none';
        }
    }

    function renderActiveBar(foundCount = null) {
        const selected = collectSelected();

        // Чипсы
        tagsBox.innerHTML = '';
        if (selected.length !== 0) {
            selected.forEach(({id, name}) => {
                const chip = document.createElement('div');
                chip.className = 'case-tag';
                chip.dataset.termId = id;
                chip.innerHTML = `
                    <span class="case-tag__remove">
                        ${name}
                        <svg width="14" height="14" aria-hidden="true" focusable="false">
                            <use href="${theme_url}/assets/img/sprite/sprite.svg#close"></use>
                        </svg>
                    </span>`;
                tagsBox.appendChild(chip);
            });
        }

        // Счётчик
        if (typeof foundCount === 'number') {
            countBox.textContent = `${foundCount} кейс(а/ов)`;
        } else {
            const total = list.children.length;
            countBox.textContent = `${total} кейс(а/ов)`;
        }
    }

    function bindTagRemovers() {
        tagsBox.querySelectorAll('.case-tag__remove').forEach(btn => {
            btn.addEventListener('click', () => {
                const chip = btn.closest('.case-tag');
                const termId = chip?.dataset.termId;
                if (!termId) return;
                const cb = checkboxes.find(c => c.value === termId);
                if (cb) cb.checked = false;
                expanded = false;
                updateButtons();
                applyFilters();
            });
        });
    }

    function updateButtons() {
        const selectedCount = collectSelected().length;

        // Применить/Сбросить доступны только при выбранных терминах и когда не идёт запрос
        setBtnEnabled(applyBtn, selectedCount > 0 && !isBusy);
        setBtnEnabled(resetBtn, selectedCount > 0 && !isBusy);

        // Показать все — если есть что раскрывать и не идёт запрос
        const totalItems = list.children.length;
        const needsShowAll = !expanded && totalItems > VISIBLE_LIMIT && showAllBtn && showAllBtn.style.display !== 'none';
        setBtnEnabled(showAllBtn, !!needsShowAll && !isBusy);
    }

    function applyFilters() {
        const selected = collectSelected();
        const termIds = selected.map(s => s.id);

        // Начало запроса — блокируем кнопки
        isBusy = true;
        updateButtons();

        loaderInstanse(list, true);

        getAjaxData(
            ajax_url,
            'filter_cases',
            {
                nonce,
                taxonomy,
                post_type: postType,
                term_ids: termIds.join(','),
                allowed_terms: allowedTerms
            },
            function (response) {
                // Конец запроса — разблокируем (ниже ещё раз вызовем updateButtons)
                isBusy = false;

                if (response && response.success && response.data) {
                    list.innerHTML = response.data.html || '<li class="case-card">Ничего не найдено.</li>';
                    // после замены DOM — схлопываем до 4
                    expanded = false;
                    truncateList();
                    // перерисовываем активбар с точным found
                    renderActiveBar(response.data.found || 0);
                    bindTagRemovers();

                    setTimeout(function (){
                        loaderInstanse(list, false);
                    }, 200)

                } else {
                    list.innerHTML = '<li class="case-card">Ошибка ответа сервера.</li>';
                    renderActiveBar();
                }
                updateButtons();
            },
            function (e) {
                isBusy = false;
                list.innerHTML = '<li class="case-card">Ошибка связи с сервером.</li>';
                console.error('ajax error:', e);
                renderActiveBar();
                updateButtons();
            }
        );
    }

    // Кнопка «Посмотреть все»
    showAllBtn?.addEventListener('click', () => {
        if (showAllBtn.hasAttribute('disabled')) return; // защита
        expanded = true;
        truncateList();
        updateButtons();
    });

    // Кнопки формы
    applyBtn?.addEventListener('click', () => {
        if (applyBtn.hasAttribute('disabled')) return;
        expanded = false;
        applyFilters();
    });

    resetBtn?.addEventListener('click', () => {
        if (resetBtn.hasAttribute('disabled')) return;
        checkboxes.forEach(cb => cb.checked = false);
        expanded = false;
        applyFilters();
    });

    // Живое обновление доступности кнопок при переключении чекбоксов
    checkboxes.forEach(cb => cb.addEventListener('change', updateButtons));

    // Первичная инициализация
    renderActiveBar();
    truncateList();
    bindTagRemovers();
    updateButtons();
});


